import styled from "styled-components";
import { transparentize } from "polished";

export const Wrapper = styled.div<{ $fullWidth: boolean }>`
  position: relative;
  display: inline-flex;
  ${(p) => p.$fullWidth && "width: 100%;"}
  text-decoration: inherit;
`;

/** Layout wrapper; keep whatever sizing you need here. */
export const TargetWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  text-decoration: inherit;
`;

export const RefAnchor = styled.span<{ $fullWidth: boolean }>`
  display: inline-flex;
  align-items: center;
  ${(p) => p.$fullWidth && "width: 100%;"}
  text-decoration: inherit;
`;

export const FloatingPanel = styled.div`
  position: fixed;
  pointer-events: auto;
  z-index: 9999;
  box-sizing: border-box;
  box-shadow: ${(p) => transparentize(0.25, p.theme.overlayMenu.shadow)} 0px 8px
    36px 0px;

  /* default desktop-ish behavior */
  overflow-x: hidden;
  overflow-y: auto;
  max-width: min(520px, calc(100vw - 16px));
  max-height: calc(100vh - 16px);
  overscroll-behavior: contain;
`;
